{
  "app.name": "Cargofollow Sign",
  "app.tagline": "Sign and inspect consignment notes on your phone.",
  "language.label": "Language",
  "language.nl": "Dutch",
  "language.en": "English",
  "language.de": "German",
  "language.fr": "French",
  "home.title": "Cargofollow Sign",
  "home.body": "Open this app through the link or QR code you received from the sender or the carrier. Without a link there is nothing to show.",
  "route.sign.title": "Sign",
  "route.sign.body": "The signing flow for this link loads here.",
  "route.inspect.title": "Inspection",
  "route.inspect.body": "The consignment note behind this inspection link is shown here.",
  "route.driver.title": "Driver",
  "route.driver.body": "Your trips are shown here.",
  "offline.body": "You are offline. What you see comes from this app's cache.",
  "error.title": "Something went wrong",
  "error.body": "Try again. If it keeps failing, ask for a new link.",
  "error.not_found.title": "Page not found",
  "error.not_found.body": "Check the link or QR code you were given.",
  "error.network": "No connection to the server.",
  "error.unexpected": "Unexpected error.",
  "loading": "Loading",
  "button.sign": "Sign",
  "button.clear": "Clear",
  "button.undo": "Undo",
  "button.confirm": "Confirm",
  "button.cancel": "Cancel",
  "button.retry": "Try again",
  "button.open": "Open",
  "button.view_pdf": "View PDF",
  "status.expired.title": "Link expired",
  "status.expired.body": "This signing link has expired. Ask the sender for a new link.",
  "status.used.title": "Already signed",
  "status.used.body": "This link has already been used. There is nothing left to do.",
  "status.revoked.title": "Link withdrawn",
  "status.revoked.body": "The party that sent this link withdrew it. Ask them for a new link.",
  "status.success.title": "Signed",
  "status.success.body": "Thank you, {name}. Your signature was recorded on {timestamp}.",
  "shipment.title": "Consignment note",
  "shipment.reference": "Reference",
  "shipment.consignor": "Consignor",
  "shipment.consignee": "Consignee",
  "shipment.carrier": "Carrier",
  "shipment.pickup": "Pickup",
  "shipment.delivery": "Delivery",
  "shipment.window": "Time window",
  "shipment.goods": "Goods",
  "shipment.goods.none": "No goods listed yet.",
  "shipment.transport": "Transport",
  "shipment.vehicle": "Registration",
  "shipment.driver": "Driver",
  "shipment.transport_type": "Type of transport",
  "shipment.charges": "Charges",
  "shipment.charges.carriage": "Carriage",
  "shipment.special_agreements": "Special agreements",
  "shipment.status.draft": "Draft",
  "shipment.status.issued": "Issued",
  "shipment.status.in_transit": "In transit",
  "shipment.status.delivered": "Delivered",
  "shipment.status.completed": "Completed",
  "shipment.status.cancelled": "Cancelled",
  "shipment.transport_type.national": "National",
  "shipment.transport_type.international": "International",
  "shipment.transport_type.cabotage": "Cabotage",
  "shipment.transport_type.combined": "Combined",
  "package_type.pallet": "pallets",
  "package_type.box": "boxes",
  "package_type.carton": "cartons",
  "package_type.crate": "crates",
  "package_type.bag": "bags",
  "package_type.drum": "drums",
  "package_type.roll": "rolls",
  "package_type.bundle": "bundles",
  "package_type.container": "containers",
  "package_type.loose": "loose",
  "package_type.other": "packages",
  "document.kind.ecmr_pdf": "Consignment note",
  "document.kind.pod_pdf": "Proof of delivery",
  "document.kind.attachment": "Attachment",
  "document.kind.signature_image": "Signature",
  "document.kind.photo": "Photo",
  "document.kind.other": "Document",
  "documents.empty.title": "No documents",
  "documents.empty.body": "As soon as a consignment note or attachment is ready, it appears here.",
  "timeline.empty.title": "No events yet",
  "timeline.empty.body": "The history of this shipment fills up as soon as something happens.",
  "event.shipment.created": "Shipment created",
  "event.shipment.issued": "Consignment note issued",
  "event.shipment.updated": "Shipment updated",
  "event.shipment.cancelled": "Shipment cancelled",
  "event.shipment.pickup_signed": "Signed at pickup",
  "event.shipment.delivered": "Delivered",
  "event.shipment.completed": "Shipment closed",
  "event.signature.completed": "Signature captured",
  "event.document.created": "Document added",
  "event.remark.added": "Remark added",
  "event.inspection.viewed": "Inspection viewed",
  "event.provider.sync_failed": "Synchronisation failed",
  "event.efti.uil_issued": "eFTI UIL issued",
  "event.efti.authority_access": "Retrieved by an authority",
  "event.efti.combined_transport_stamped": "Combined transport stamp",
  "actor.api_key": "API key",
  "actor.user": "User",
  "actor.signer": "Signer",
  "actor.provider": "Platform",
  "actor.system": "System",
  "actor.public": "Public link",
  "actor.authority": "Authority",
  "signature.hint": "Draw your signature in the box.",
  "signature.ready": "Signature captured.",
  "sign.role.consignor": "Sender",
  "sign.role.carrier": "Carrier",
  "sign.role.consignee": "Consignee",
  "sign.intro": "You are signing this consignment note as the {role}.",
  "sign.expires": "This link is valid until {timestamp}.",
  "sign.documents.title": "Documents",
  "sign.signatures.title": "Already signed",
  "sign.signatures.none": "Nobody has signed yet.",
  "sign.signatures.entry": "{name} · {timestamp}",
  "sign.start": "Continue to signing",
  "sign.step.title": "Your signature",
  "sign.field.name": "Name",
  "sign.field.name.error": "Fill in your name.",
  "sign.field.company": "Company",
  "sign.field.company.hint": "Optional.",
  "sign.field.signature": "Signature",
  "sign.field.signature.error": "Draw your signature in the box first.",
  "sign.signature.too_large": "The signature does not fit the size limit. Clear it and draw it more simply.",
  "sign.consent.label": "I sign this consignment note electronically and agree to the eCMR conditions.",
  "sign.consent.error": "Agree before you sign.",
  "sign.geo.label": "Share my location with this signature",
  "sign.geo.pending": "Getting your location…",
  "sign.geo.captured": "Location recorded.",
  "sign.geo.denied": "No location available. You can still sign.",
  "sign.submit": "Sign",
  "sign.submitting": "Sending",
  "sign.back": "Back to the consignment note",
  "sign.success.signed_as": "Signed as the {role}",
  "sign.success.consignee_note": "The proof of delivery follows later. There is nothing left to do on this link.",
  "sign.success.no_pdf": "No PDF is ready yet.",
  "sign.method.title": "How do you want to sign?",
  "sign.method.intro": "You are signing this consignment note as {role}. Choose how.",
  "sign.method.drawn.title": "Sign on screen",
  "sign.method.drawn.body": "Draw your signature with your finger.",
  "sign.method.click_otp.title": "Confirm with a code",
  "sign.method.click_otp.body": "You get a six-digit code and confirm with one tap.",
  "sign.otp.title": "Confirm with a code",
  "sign.otp.intro": "Fill in your name, agree, and we will send you a six-digit code.",
  "sign.otp.channel.label": "Where should the code go?",
  "sign.otp.channel.email": "By e-mail",
  "sign.otp.channel.sms": "By text message",
  "sign.otp.send": "Send the code",
  "sign.otp.sending": "Sending the code",
  "sign.otp.code.title": "Enter the code",
  "sign.otp.sent": "We sent a code to {destination}.",
  "sign.otp.code.label": "Six-digit code",
  "sign.otp.code.hint": "The code is valid for ten minutes.",
  "sign.otp.code.error": "Fill in all six digits.",
  "sign.otp.resend": "Send a new code",
  "sign.otp.resend.wait": "New code in {seconds} seconds",
  "sign.otp.confirm": "Confirm and sign",
  "sign.otp.confirming": "Confirming",
  "sign.otp.error.invalid": "That code is not correct. Check the message and try again.",
  "sign.otp.error.locked": "Too many wrong codes. Ask for a new code in a few minutes.",
  "sign.otp.error.expired": "This code has expired. Ask for a new one.",
  "sign.otp.error.rate_limited": "Too many codes were requested. Wait a moment and try again.",
  "sign.otp.error.send": "The code could not be sent. Try again, or sign on screen.",
  "sign.otp.error.unavailable": "This link has no e-mail address or phone number for a code. Sign on screen instead.",
  "pickup.title": "Loading and signing",
  "pickup.intro": "The sender and the carrier sign this consignment note together at loading.",
  "pickup.parties.title": "Signatures",
  "pickup.party.signed": "Signed by {name} on {timestamp}.",
  "pickup.party.signed_elsewhere": "Signed on another device.",
  "pickup.party.signed_name": "Signed by {name}.",
  "pickup.party.queued": "Signed by {name}, not sent yet. That happens by itself as soon as you are online again.",
  "pickup.party.queued_stopped": "Signed by {name}, but not sent. Check the queue.",
  "pickup.party.waiting": "Not signed yet.",
  "pickup.party.no_link": "No sign link was created for this role.",
  "pickup.party.link_used": "This sign link has already been used.",
  "pickup.party.link_expired": "This sign link has expired.",
  "pickup.party.link_revoked": "This sign link was withdrawn.",
  "pickup.action.sign_here": "Sign here",
  "pickup.action.own_device": "On own device",
  "pickup.handoff.title": "On own device: {role}",
  "pickup.handoff.body": "Let the signer scan this QR code. The link works once and stays valid for ten minutes.",
  "pickup.handoff.qr_alt": "QR code to the sign link",
  "pickup.handoff.open": "Open link",
  "pickup.handoff.expires": "Valid until {timestamp}.",
  "pickup.handoff.waiting": "Waiting for the signature…",
  "pickup.handoff.creating": "Creating QR code",
  "pickup.handoff.failed": "The QR code could not be created.",
  "pickup.handoff.back": "Back to the overview",
  "pickup.queued.back": "Back to the overview",
  "pickup.done.title": "Signed off at loading",
  "pickup.done.body": "The sender and the carrier have both signed.",
  "pickup.done.status": "Status of the shipment: {status}",
  "pickup.done.signature": "{role}: {name} · {timestamp}",
  "pickup.unusable.title": "Not a pickup session",
  "pickup.unusable.body": "This link does not belong to loading. Open the link you received from the sender or the carrier.",
  "delivery.title": "Delivery",
  "delivery.intro": "Check the packages, record any reservations and let the consignee sign.",
  "delivery.step": "Step {current} of {total}",
  "delivery.back": "Back",
  "delivery.colli.title": "Check the packages",
  "delivery.colli.body": "Enter how many packages you received for every line of goods.",
  "delivery.colli.expected": "Expected: {count} {package_type}",
  "delivery.colli.received": "Received",
  "delivery.colli.error": "Enter a number of 0 or more.",
  "delivery.colli.empty": "This consignment note lists no goods.",
  "delivery.colli.total": "Total: {received} of {expected} packages.",
  "delivery.colli.line": "{description}: {received} of {expected} received.",
  "delivery.colli.match": "The counts match.",
  "delivery.colli.shortage": "{count, plural, one {# package is} other {# packages are}} missing. Record this as a reservation.",
  "delivery.colli.surplus": "{count, plural, one {# package} other {# packages}} too many. Record this as a reservation.",
  "delivery.remark.title": "Reservations",
  "delivery.remark.body": "Report damage, a shortage or a delay on this delivery.",
  "delivery.remark.required": "The counts differ, so record a reservation.",
  "delivery.remark.type": "Kind of reservation",
  "delivery.remark.type.damage": "Damage",
  "delivery.remark.type.shortage": "Shortage",
  "delivery.remark.type.delay": "Delay",
  "delivery.remark.type.other": "Other",
  "delivery.remark.text": "Description",
  "delivery.remark.text.hint": "Describe briefly what is wrong.",
  "delivery.remark.text.error": "Describe the reservation.",
  "delivery.remark.photos": "Photos",
  "delivery.remark.photos.hint": "At most {max} photos. Large photos are shrunk before they are sent.",
  "delivery.remark.photos.add": "Add a photo",
  "delivery.remark.photos.full": "You can send at most {max} photos.",
  "delivery.remark.photo.alt": "Photo {number}",
  "delivery.remark.photo.compressing": "Shrinking…",
  "delivery.remark.photo.uploading": "Sending… {percent}%",
  "delivery.remark.photo.stored": "Sent · {size}",
  "delivery.remark.photo.failed": "Sending failed.",
  "delivery.remark.photo.unreadable": "This photo cannot be read.",
  "delivery.remark.photo.retry": "Send again",
  "delivery.remark.photo.remove": "Remove",
  "delivery.remark.photo.waiting": "Wait until the photos have been sent.",
  "delivery.remark.submit": "Record the reservation",
  "delivery.remark.submitting": "Recording",
  "delivery.remark.skip": "No reservations",
  "delivery.remark.failed": "The reservation could not be recorded. Please try again.",
  "delivery.device.title": "Who signs where?",
  "delivery.device.body": "The consignee signs on your device, or on a device of their own through a QR code.",
  "delivery.device.driver": "The consignee signs here",
  "delivery.device.driver.hint": "On your device. That is recorded with the signature.",
  "delivery.device.own": "On their own device",
  "delivery.device.own.hint": "The consignee scans a QR code and signs on their own phone.",
  "delivery.handoff.back": "Back to the choice",
  "delivery.done.title": "Delivered",
  "delivery.done.body": "The consignment note was signed off on delivery.",
  "delivery.done.status": "Status of the shipment: {status}",
  "delivery.done.signed": "Signed by {name} on {timestamp}.",
  "delivery.done.signed_elsewhere": "Signed on the device of the consignee.",
  "delivery.done.device.driver": "Signed on the driver device.",
  "delivery.done.device.own": "Signed on the consignee own device.",
  "delivery.pod.title": "Proof of delivery",
  "delivery.pod.colli": "Packages: {received} of {expected} received.",
  "delivery.pod.colli.unknown": "Packages: not counted on this device.",
  "delivery.pod.remarks.none": "No reservations recorded.",
  "delivery.pod.remark": "{type}: {text}",
  "delivery.pod.remark.untyped": "{type}",
  "delivery.pod.remark.photos": "{count, plural, one {# photo} other {# photos}}",
  "delivery.pod.download": "Download the proof of delivery",
  "delivery.pod.pdf": "Proof of delivery (PDF)",
  "delivery.pod.pdf.pending": "The PDF of the proof of delivery is not ready yet.",
  "fixtures.title": "Components",
  "fixtures.shipment": "ShipmentView",
  "fixtures.timeline": "Timeline",
  "fixtures.documents": "DocumentList",
  "fixtures.signature": "SignaturePad",
  "fixtures.signature.export": "Export PNG",
  "fixtures.signature.exported": "PNG of {width}×{height} px, {bytes} bytes.",
  "fixtures.signature.empty": "Nothing drawn yet.",
  "shipment.not_provided": "Not provided",
  "shipment.box": "Box {number}",
  "shipment.goods.table": "Goods (boxes 6 to 12)",
  "shipment.driver.hidden": "The driver's contact details are not shown.",
  "shipment.driver.phone": "Driver's phone",
  "shipment.signature.method": "Method",
  "shipment.signature.trust": "Trust level",
  "shipment.signature.qtsp": "Trust service",
  "shipment.signature.hash": "Version hash",
  "shipment.signature.verified": "Matches the current version",
  "shipment.signature.superseded": "Signed on an earlier version",
  "shipment.signature.method.drawn": "Signed on glass",
  "shipment.signature.method.click_otp": "Confirmed with a one-time code",
  "shipment.signature.method.api": "Through the system's API",
  "shipment.signature.method.photo_of_paper": "Photo of a paper signature",
  "shipment.signature.trust.platform_auth": "Platform authentication",
  "shipment.signature.trust.ades": "Advanced (AdES)",
  "shipment.signature.trust.qes": "Qualified (QES)",
  "inspect.title": "Consignment note",
  "inspect.subtitle": "Read-only view through the QR code on the consignment note.",
  "inspect.version": "Version {version}",
  "inspect.viewed_at": "Viewed on {timestamp}",
  "inspect.expires": "This inspection link is valid until {timestamp}.",
  "inspect.integrity.ok.title": "Chain intact",
  "inspect.integrity.ok.body": "{events} events, unbroken since the shipment was created.",
  "inspect.integrity.broken.title": "Chain broken",
  "inspect.integrity.broken.body": "The events of this shipment do not match their hash chain. Contact the carrier.",
  "inspect.integrity.head_hash": "Head hash",
  "inspect.documents.title": "Documents",
  "inspect.pdf.download": "Download the consignment note (PDF)",
  "inspect.pdf.none": "No PDF of this consignment note is ready yet.",
  "inspect.print": "Print",
  "inspect.expired.title": "Inspection link expired",
  "inspect.expired.body": "This inspection link has expired. Ask the carrier for a current QR code.",
  "inspect.rotated.title": "Inspection link replaced",
  "inspect.rotated.body": "This inspection link was replaced. Scan the QR code on the current consignment note.",
  "inspect.not_found.title": "Unknown inspection link",
  "inspect.not_found.body": "Check the QR code on the consignment note.",
  "driver.title": "Sign in as a driver",
  "driver.intro": "Enter the phone number your planner put on the shipment. You will get a code by text message.",
  "driver.country.label": "Country",
  "driver.phone.label": "Phone number",
  "driver.phone.hint": "Without the country code; we put {prefix} in front of it.",
  "driver.error.phone_invalid": "This does not look like a valid phone number.",
  "driver.button.send_code": "Send me a code",
  "driver.code.title": "Enter the code",
  "driver.code.body": "We sent a six-digit code to {phone}.",
  "driver.code.label": "Code",
  "driver.code.hint": "Six digits, valid for ten minutes.",
  "driver.button.verify": "Sign in",
  "driver.button.change_number": "Use another number",
  "driver.error.code_invalid": "This code is wrong or expired. Ask for a new one.",
  "driver.error.locked": "Too many attempts. Wait a few minutes and then ask for a new code.",
  "driver.error.session_expired": "Your session has expired. Sign in again.",
  "driver.list.title": "Your trips",
  "driver.sandbox.title": "Sandbox",
  "driver.sandbox.body": "This number is only on practice shipments. Nothing you see here is a real trip.",
  "driver.button.sign_out": "Sign out",
  "driver.button.refresh": "Refresh",
  "driver.empty.title": "Nothing open",
  "driver.empty.body": "There is no open trip on this number. If that is wrong, ask your planner to put your number on the shipment.",
  "driver.action.load": "Load",
  "driver.action.deliver": "Unload",
  "driver.reference.none": "No reference",
  "driver.ordered_by": "On behalf of {party}",
  "driver.window.none": "No time window agreed",
  "driver.then.deliver": "Then unload at {party} in {city}.",
  "driver.then.loaded": "Loaded at {party} in {city}.",
  "driver.signed_off": "Already signed off.",
  "driver.button.open_pickup": "Load and sign",
  "driver.button.open_delivery": "Deliver and have it signed",
  "driver.button.navigate": "Navigate",
  "driver.tour.untitled": "Unnamed run",
  "driver.tour.progress": "{done} of {total} stops",
  "driver.tour.loose": "Single rides",
  "driver.tour.stop.numbered": "Stop {position} · {action}",
  "driver.tour.stop.done": "Signed off",
  "driver.tour.stop.waiting": "Not your turn yet",
  "driver.tour.stop.closed": "No longer open",
  "queue.title": "Queue",
  "queue.body": "These submissions are waiting on this device. They are sent by themselves as soon as there is a connection again.",
  "queue.badge": "{count} queued",
  "queue.empty.title": "Nothing queued",
  "queue.empty.body": "Everything you recorded has been sent.",
  "queue.kind.photo": "Photo",
  "queue.kind.remark": "Reservation",
  "queue.kind.signature": "Signature",
  "queue.state.pending": "Waiting for a connection",
  "queue.state.sending": "Sending",
  "queue.state.conflict": "Handled elsewhere",
  "queue.state.failed": "Not sent",
  "queue.captured": "Recorded at {timestamp}",
  "queue.hash": "Content hash {hash}",
  "queue.attempts": "Attempts: {count}",
  "queue.reason.queue_blocked": "Not sent: an earlier submission of the same errand got stuck.",
  "queue.reason.hash_mismatch": "Not sent: the stored content does not match the hash taken when it was recorded.",
  "queue.reason.already_signed": "This consignment note has since been signed on another device. This submission is no longer needed.",
  "queue.reason.link_expired": "The link expired before this submission could be sent.",
  "queue.reason.network": "The server could not be reached. You can try again.",
  "queue.reason.refused": "The server refused this submission ({code}).",
  "queue.retry": "Try again",
  "queue.discard": "Discard",
  "queue.offline": "No connection. The queue waits until you are online again.",
  "queue.done.title": "Recorded, not sent yet",
  "queue.done.body": "You have no connection. What you recorded is safe on this device and is sent by itself as soon as you are online again.",
  "queue.done.status": "Will be sent as soon as you are online",
  "queue.done.open": "View the queue",
  "delivery.remark.photo.queued": "Queued, sent as soon as you are online",
  "sign.identification.title": "Identify yourself first",
  "sign.identification.intro": "This consignment note asks for {level}. Identify yourself at {provider} first; after that you sign as usual.",
  "sign.identification.why": "The trust service establishes who you are and then signs exactly this version of the consignment note.",
  "sign.identification.start": "Identify at {provider}",
  "sign.identification.retry": "Try again",
  "sign.identification.waiting": "Identifying",
  "sign.identification.waiting.body": "Waiting for {provider} to confirm your identification. This screen continues by itself.",
  "sign.identification.level.ades": "an advanced signature (AdES)",
  "sign.identification.level.qes": "a qualified signature (QES)"
}
